import { ResourceAppModule } from "@/shared/app";
import { revisionModuleRouteConfig } from "@/shared/resourceRouteConfig";
import {
  ProductionRecipe,
  productionRecipeResource,
} from "@megarax/client/src/resources/plm";
import { RouteConfig } from "vue-router";
import { plmApp } from "../app";

export const productionRecipeModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Receptury produkcyjne",
  route: "recepturaProdukcyjna",
  iconClass: "fa-fw fas fa-industry",
  itemConstructor: ProductionRecipe,
  resource: productionRecipeResource,
};

const baseRouteConfig = revisionModuleRouteConfig(productionRecipeModule);
export const productionRecipeRouteConfig: RouteConfig = {
  ...baseRouteConfig,
  children: [
    {
      path: "tabelaSkladnikow",
      component: () => import("./IngredientTableCsvDownload.vue"),
    },
    ...baseRouteConfig.children!,
  ],
};
